import "./buttons.scss";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * BackButton component renders a chevron left icon and blue clickable text "Back"
 * that triggers a callback function when clicked.
 * The button is only visible if the `visible` prop is true.
 *
 * @param {Object} props - The props object.
 * @param {Function} props.handleClick - The callback function to be called when the button is clicked.
 * @param {boolean} [props.visible=true] - Determines whether the button is visible or not.
 * @returns {JSX.Element|null} The rendered button element or null if not visible.
 */
const BackButton = ({ handleClick, visible = true }) => {
  if (!visible) {
    return null;
  }

  return (
    <button className="btn-text-blue base navigate width-fit p-0" onClick={handleClick}>
      <strong>
        <FontAwesomeIcon icon={faChevronLeft} /> Back
      </strong>
    </button>
  );
};

export default BackButton;
